import { FC } from 'react'
import { ModalFrame } from '@/UI/Modals/ModalParts'

type ContactSalesModalProps = {
  onClose: () => void
}

export const ContactSalesModal: FC<ContactSalesModalProps> = ({ onClose }) => (
  <ModalFrame
    show
    onHide={onClose}
    dialogClassName="grid-sales-dialog"
    contentClassName="grid-sales-modal-content"
  >
    <iframe
      title="hubspot"
      style={{
        width: '100%',
        height: '666px',
      }}
      src={process.env.NEXT_PUBLIC_HUBSPOT_MEETINGS_LINK}
    />
  </ModalFrame>
)

export default ContactSalesModal
